<script setup>
import { computed } from "vue";
import { Close, Download } from "@element-plus/icons-vue";
import { AddTutorClientDownloadsLog } from "@/api/system";
import infoIcon from "@/assets/img/common/info.png";

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  /** 1 = Welcome 下载引导；2 = 系统迁移通知（接口文案） */
  sort: { type: Number, default: 1 },
  title: { type: String, default: "" },
  content: { type: String, default: "" },
});

const emit = defineEmits(["update:modelValue"]);

const visible = computed({
  get: () => props.modelValue,
  set: (v) => emit("update:modelValue", v),
});

const WIN_URL = "https://cdnstatic.acadsoc.com.cn/download/tutor/TutorClient_latest.exe";
const MAC_URL = "https://cdnstatic.acadsoc.com.cn/download/tutor/TutorClient_latest.dmg";
const GUIDE_URL =
  "https://files.acadsoc.com.cn/tutor/coursewareresources/20201107/7c611da1-47c6-42f5-a4f3-0953ebdfa30b.mp4";

function clientInfo() {
  return `platform:${navigator.platform},userAgent:${navigator.userAgent}`;
}

function downloadWin() {
  AddTutorClientDownloadsLog(1, clientInfo(), 1).catch(() => {});
  window.location.href = WIN_URL;
}

function downloadMac() {
  AddTutorClientDownloadsLog(1, clientInfo(), 2).catch(() => {});
  window.location.href = MAC_URL;
}
</script>

<template>
  <el-dialog
    v-model="visible"
    width="750px"
    align-center
    append-to-body
    :show-close="false"
    class="client-download-dialog"
  >
    <div class="cd-head">
      <h3 class="cd-title" :class="sort === 1 ? 'is-blue' : 'is-pink'">
        {{ sort === 1 ? "Download TutorClient" : title }}
      </h3>
      <button type="button" class="cd-close" title="close" @click="visible = false">
        <el-icon :size="20"><Close /></el-icon>
      </button>
    </div>

    <div v-if="sort === 1" class="cd-body">
      <ol class="cd-list">
        <li class="urgent">
          <strong>URGENT NOTICE:</strong><br />
          The A-Classroom Client is scheduled to go offline on November 30th, 2020 and will be
          stopped using. Please download TutorClient now in case you can't take classes then.
        </li>
        <li>
          TutorClient Advantages:running smoothly,no need to switch between pages,more stable
          classroom.
        </li>
        <li>
          Installation notice:You may see a security message from windows,select MORE INFO and click
          RUN ANYWAY,it won't damage your computer.
        </li>
      </ol>
    </div>
    <div v-else class="cd-body transfer" v-html="content" />

    <div class="cd-actions">
      <div class="cd-col">
        <button type="button" class="tutor-blue-btn dl-btn" @click="downloadWin">
          <el-icon><Download /></el-icon>
          Windows Download
        </button>
        <a class="guide-link" :href="GUIDE_URL" target="_blank" rel="noopener noreferrer">
          <img :src="infoIcon" alt="" />
          <span>Installation Guide</span>
        </a>
      </div>
      <div class="cd-col">
        <button type="button" class="tutor-blue-btn dl-btn" @click="downloadMac">
          <el-icon><Download /></el-icon>
          Mac Download
        </button>
      </div>
    </div>
  </el-dialog>
</template>

<style scoped lang="scss">
.cd-head {
  position: relative;
  text-align: center;
  padding: 4px 32px 8px;
}

.cd-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;

  &.is-blue {
    color: #32397a;
  }
  &.is-pink {
    color: #f69898;
  }
}

.cd-close {
  position: absolute;
  right: 0;
  top: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #5b6195;
  line-height: 1;
  padding: 4px;

  &:hover {
    color: #32397a;
  }
}

.cd-body {
  color: #32397a;
  font-size: 14px;
  line-height: 1.55;
}

.cd-list {
  margin: 0;
  padding-left: 1.2em;

  li {
    margin-bottom: 10px;
  }

  .urgent {
    color: #ee344c;
    font-weight: 700;
  }
}

.transfer {
  color: #f69898;
  list-style: none;

  :deep(ul) {
    list-style: none;
    padding-left: 0;
  }
}

.cd-actions {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: 20px;
  padding-bottom: 4px;
}

.cd-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.dl-btn {
  width: 197px;
  height: 32px !important;
  gap: 6px;
}

.guide-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  text-decoration: none;
  color: #32397a;
  font-weight: 700;

  img {
    width: 18px;
    height: 18px;
    vertical-align: middle;
  }

  &:hover {
    opacity: 0.85;
  }
}
</style>

<style lang="scss">
.client-download-dialog.el-dialog {
  border-radius: 8px;
}

.client-download-dialog .el-dialog__header {
  display: none;
}

.client-download-dialog .el-dialog__body {
  padding: 16px 24px 20px;
}
</style>
